"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "FatalErrorBoundary", {
  enumerable: true,
  get: function () {
    return _FatalErrorBoundary.default;
  }
});

_Object$defineProperty(exports, "FetchConfigProvider", {
  enumerable: true,
  get: function () {
    return _FetchConfigProvider.FetchConfigProvider;
  }
});

_Object$defineProperty(exports, "useFetchConfig", {
  enumerable: true,
  get: function () {
    return _FetchConfigProvider.useFetchConfig;
  }
});

_Object$defineProperty(exports, "GraphQLHooksProvider", {
  enumerable: true,
  get: function () {
    return _GraphQLHooksProvider.GraphQLHooksProvider;
  }
});

_Object$defineProperty(exports, "useQuery", {
  enumerable: true,
  get: function () {
    return _GraphQLHooksProvider.useQuery;
  }
});

_Object$defineProperty(exports, "useMutation", {
  enumerable: true,
  get: function () {
    return _GraphQLHooksProvider.useMutation;
  }
});

_Object$defineProperty(exports, "createCell", {
  enumerable: true,
  get: function () {
    return _createCell.createCell;
  }
});

_Object$defineProperty(exports, "useFlash", {
  enumerable: true,
  get: function () {
    return _flash.useFlash;
  }
});

_Object$defineProperty(exports, "Flash", {
  enumerable: true,
  get: function () {
    return _flash.Flash;
  }
});

exports.withCell = void 0;

require("./global.web-auto-imports");

require("./config");

var _FatalErrorBoundary = _interopRequireDefault(require("./components/FatalErrorBoundary"));

var _FetchConfigProvider = require("./components/FetchConfigProvider");

var _GraphQLHooksProvider = require("./components/GraphQLHooksProvider");

var _createCell = require("./components/createCell");

var _flash = require("./flash");

/** @deprecated `withCell` will be removed in v0.32.0, please use `createCell` instead. */
const withCell = _createCell.createCell; // TODO: Remove these in v.10, people can import from `@redwoodjs/web/toast`
// deprecated

exports.withCell = withCell;